import { Injectable } from '@angular/core';
import { Actions, EffectNotification, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { exhaustMap, map } from 'rxjs/operators';
import { start, finish } from './initializer.actions';

@Injectable()
export class InitializerEffects {

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>) {
    return this.actions$
        .pipe(
            ofType(start),
            exhaustMap (() => resolvedEffects$.pipe(
              map(() => finish())
            ))
        );
  }

  constructor(private actions$: Actions) {}

}
